import { ReactComponent as LogoW } from '../assets/images/logo-w.svg';
import { LuHome } from "react-icons/lu";
import { LuInstagram } from "react-icons/lu";
import { LuYoutube } from "react-icons/lu";
import { ReactComponent as NBlog } from '../assets/images/icon-naver.svg';
import { ReactComponent as Bon } from '../assets/images/icon-bon.svg';

export default function Footer() {

  const copyright = {
    background: "#000",
    textAlign: "center", 
    color: "#d1d1d1", 
    padding: "10px 0", 
    fontSize: "0.6rem",
  }

  return (
    <footer>
      <div className="footer-inner flex flex-wrap">
          <div><LogoW width="200px" opacity={0.5} /></div>
          <div className="sns flex">
          <a id="blog-button" href="https://www.bongroup.co.kr/" target="Blank"><Bon /></a>
            <a id="babyweb-button2" href="https://www.bonif.co.kr/brand?brdCd=BF101" target="Blank"><LuHome color="#fff" /></a>
            <a id="insta-button" href="https://www.instagram.com/bonjukofficial/" target="Blank"><LuInstagram color="#fff" /></a>
            <a id="youtube-button" href="https://www.youtube.com/@본그룹_꼬르륵" target="Blank"><LuYoutube color="#fff" /></a>
            <a id="blog-button" href="https://blog.naver.com/bonlove09" target="Blank"><NBlog /></a>
          </div>
      </div>

      <div style={copyright}>
        
        <p style={{ padding: "8px 0 0", fontSize: "16px", fontWeight: "600" }}>본그룹 사회공헌&nbsp;&nbsp;|&nbsp;&nbsp;정성 한 그릇, 행복 한 그릇</p>
        <p style={{ padding: "6px",fontSize: "9px" }}>COPYRIGHT © BY BON GROUP. ALL RIGHT RESERVED</p>
        
      </div>

    </footer>
  );
};

